import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import { graphql, ChildProps } from 'react-apollo';
import MarketplacePage from './marketplace_page';
import { CoreAdBannerWrapper } from '../../schemas/rql';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { adBannerQuery } from '@reverbdotcom/commons/src/components/ads/ad_fragments';
import { parseKeywords } from '@reverbdotcom/commons/src/components/ads/ad_banner_helpers';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { PageSettings } from './map_params';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';

interface IExternalProps {
  emptyGrid?: JSX.Element;
  pageSettings?: PageSettings;
  pageName?: MParticlePageName;
  renderCollectionHeaderDescription?: boolean;
  skipHeader?: boolean;
  hideFooter?: boolean;
  hideFollowButtons?: boolean;
}

type IProps = WithRouterProps & IUserContext & IExternalProps & ChildProps<{}, CoreAdBannerWrapper.Query> ;

const adQuery = graphql<IProps, CoreAdBannerWrapper.Query, CoreAdBannerWrapper.Variables>(adBannerQuery,
  {
    options: (ownProps) => {
      return {
        variables: { keywords: parseKeywords(ownProps.location, ownProps.params) },
      };
    },
  },
);

export function MarketplacePageWrapper(props: IProps) {
  const { params, location } = props;

  return (
    <MarketplacePage
      location={location}
      params={params}
      emptyGrid={props.emptyGrid}
      hideFollowButtons={props.hideFollowButtons}
      pageSettings={props.pageSettings || { useExperimentalRecall: isExperimentEnabled(props.user, experiments.SEARCH_RECALL_IMPROVEMENTS) }}
      pageName={props.pageName || MParticlePageName.Marketplace}
      renderCollectionHeaderDescription={props.renderCollectionHeaderDescription}
      skipHeader={props.skipHeader}
      hideFooter={props.hideFooter}
      loading={props.data?.loading}
      ad={props.data?.adServe?.ad}
    />
  );
}

export default withUserContext<IExternalProps>(withRouter(adQuery(MarketplacePageWrapper)));
